/**
 * The comp share page's address, /s/:token (audit row N14). Imports nothing,
 * so main.tsx, the Sentry wrapper and the share page's own entry can all ask
 * it before anything else loads.
 *
 * The token in that address is a secret: anyone holding it sees a family's
 * children's first names and where they will be on comp day. So nothing that
 * reports the page's address anywhere (Sentry, its replay, a service worker)
 * starts on it, and sentryBreadcrumbs.ts scrubs the address from anything
 * that reports it anyway.
 */
export function isCompSharePath(pathname: string): boolean {
  return pathname.startsWith('/s/');
}
